import * as Flickity from 'flickity'
import * as $ from 'jquery'

const slider = function() {
  
    let sliderContainer = document.querySelectorAll('.block-slider')
  
    Array.prototype.forEach.call(sliderContainer, function(container, i){
      let slider = container.querySelector('.block-slider')
  
      if(slider !== null) {
        let flkty = new Flickity(slider, {
          wrapAround: true,
          rightToLeft: false,
          cellSelector: '.block-slider-slide',
          prevNextButtons: false,
          pageDots: false
        })
        
        
        if (slider > 0) {
          let next = container.querySelector('.trigger-right')
          let prev = container.querySelector('.trigger-left')
          
          console.log(next)

          next.addEventListener('click', () => { 
            console.log('next')
            flkty.next() 
          })
          prev.addEventListener('click', () => { 
            console.log('prev')
            flkty.previous() 
          })
        }
      }
      // More informations cards
      let infosBtn = $(container).find('.trigger-info')
      let infosContent = $(container).find('.drawer')
    })
}

slider()


// WEBPACK FOOTER //
// ./src/app.js